import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  CircularProgress,
  Stack,
} from "@chakra-ui/react";
import { ArrowUpIcon, ArrowDownIcon } from "@chakra-ui/icons";
import moment from "moment";
import { regionalFormattingNumbers } from "../../../utils/regionalFormattingNumbers";
import EditarEtapa from "../../operaciones/components/curso/etapas/EditarEtapa";
import EliminarEtapa from "../../operaciones/components/curso/etapas/EliminarEtapa";
import { tnsToLbs } from "../../../utils/handleWeightConversion";
import "../../../styles/TablaEtapas.css";

function TablaEtapas(props) {
  const {
    loading,
    sortData,
    sortDirection,
    sortField,
    user,
    filteredEtapas,
    setSeleccionado,
    seleccionado,
    setOpenDetalle,
    initData,
  } = props;
  return (
    <Stack
      className="container_table_etapas_op"
      placeSelf="self-start"
      w={"100%"}
      overflowY="auto"
    >
      <TableContainer
        // className="table-container-reporteEtapas"
        overflowY="auto"
      >
        <Table variant={"simple"} size={"sm"}>
          <Thead
            // position="sticky"
            // alignContent={"center"}
            // top={0}
            // left={0}
            // zIndex="1"
            // display={"block"}
            // width={"100%"}
            style={{
              position: "sticky",
              top: 0,
              zIndex: 1,
              backgroundColor: "#F3F6F9",
              opacity: 1,
            }}
          >
            <Tr>
              <Th
                // padding={0}
                // paddingRight={5}
                // marging={0}
                _hover={{ cursor: "pointer" }}
                onClick={() => sortData("padLocacion")}
                textAlign={"left"}
              >
                PAD
                {sortDirection === "asc" && sortField === "padLocacion" && (
                  <ArrowUpIcon />
                )}
                {sortDirection === "desc" && sortField === "padLocacion" && (
                  <ArrowDownIcon />
                )}
              </Th>
              <Th
                // padding={0}
                // paddingRight={5}
                // marging={0}
                _hover={{ cursor: "pointer" }}
                onClick={() => sortData("numTotalEtapaSC")}
                // width={seleccionado ? "9%" : "8%"}
                textAlign={"end"}
              >
                Nro Etapa <br /> (total)
                {sortDirection === "asc" && sortField === "numTotalEtapaSC" && (
                  <ArrowUpIcon />
                )}
                {sortDirection === "desc" &&
                  sortField === "numTotalEtapaSC" && <ArrowDownIcon />}
              </Th>
              <Th
                // padding={0}
                // paddingRight={5}
                // marging={0}
                _hover={{ cursor: "pointer" }}
                onClick={() => sortData("numPozoEtapaSC")}
                // width={seleccionado ? "8%" : "8%"}
                textAlign={"end"}
              >
                Nro Etapa <br /> (pozo)
                {sortDirection === "asc" && sortField === "numPozoEtapaSC" && (
                  <ArrowUpIcon />
                )}
                {sortDirection === "desc" && sortField === "numPozoEtapaSC" && (
                  <ArrowDownIcon />
                )}
              </Th>
              <Th
                // padding={0}
                // paddingRight={5}
                // marging={0}
                _hover={{ cursor: "pointer" }}
                onClick={() => sortData("pozo.nombrePozo")}
                // width={seleccionado ? "10.15%" : "10.35%"}
                textAlign={"left"}
              >
                ID <br /> Pozo
                {sortDirection === "asc" && sortField === "pozo.nombrePozo" && (
                  <ArrowUpIcon />
                )}
                {sortDirection === "desc" &&
                  sortField === "pozo.nombrePozo" && <ArrowDownIcon />}
              </Th>
              <Th
                // padding={0}
                // paddingRight={5}
                // marging={0}
                _hover={{ cursor: "pointer" }}
                onClick={() => sortData("etapaWeTSanD")}
                // width={seleccionado ? "7.25%" : "8.75%"}
                textAlign={"left"}
              >
                Wetsand
                {sortDirection === "asc" && sortField === "etapaWeTSanD" && (
                  <ArrowUpIcon />
                )}
                {sortDirection === "desc" && sortField === "etapaWeTSanD" && (
                  <ArrowDownIcon />
                )}
              </Th>
              <Th
                // padding={0}
                // paddingRight={5}
                // marging={0}
                _hover={{ cursor: "pointer" }}
                onClick={() => sortData("fechaFinalEtapaSC")}
                // width={seleccionado ? "9.75%" : "9.75%"}
                textAlign={"left"}
              >
                Fecha
                {sortDirection === "asc" &&
                  sortField === "fechaFinalEtapaSC" && <ArrowUpIcon />}
                {sortDirection === "desc" &&
                  sortField === "fechaFinalEtapaSC" && <ArrowDownIcon />}
              </Th>
              <Th
                // padding={0}
                // paddingRight={5}
                // marging={0}
                _hover={{ cursor: "pointer" }}
                onClick={() => sortData("sandCubes.length")}
                // width={seleccionado ? "5%" : "8%"}
                textAlign={"center"}
              >
                Cant. <br /> SCs.
                {sortDirection === "asc" &&
                  sortField === "sandCubes.length" && <ArrowUpIcon />}
                {sortDirection === "desc" &&
                  sortField === "sandCubes.length" && <ArrowDownIcon />}
              </Th>
              <Th
                // padding={0}
                // paddingRight={5}
                // marging={0}
                _hover={{ cursor: "pointer" }}
                onClick={() => sortData("etapa.consumidoSC")}
                // width={seleccionado ? "7%" : "7%"}
                textAlign={"end"}
              >
                Tns. Cons.
                <br /> SC
              </Th>
              <Th
                // padding={0}
                // paddingRight={5}
                // marging={0}
                _hover={{ cursor: "pointer" }}
                onClick={() => sortData("etapa.consumidoGranel")}
                // width={"7%"}
                textAlign={"end"}
              >
                Tns. Cons. <br /> Granel
              </Th>
              <Th
                // padding={0}
                // paddingRight={5}
                // marging={0}
                _hover={{ cursor: "pointer" }}
                onClick={() => sortData("etapa.consumidoGranel")}
                // width={seleccionado ? "10%" : "9%"}
                textAlign={"end"}
              >
                Lbs. Cons. <br /> Granel
              </Th>
              <Th
                // padding={0}
                // paddingRight={5}
                // marging={0}
                _hover={{ cursor: "pointer" }}
                onClick={() => sortData("estado")}
                // width={seleccionado ? "5%" : "3%"}
                textAlign={"end"}
              >
                Tns.
                {sortDirection === "asc" && sortField === "estado" && (
                  <ArrowUpIcon />
                )}
                {sortDirection === "desc" && sortField === "estado" && (
                  <ArrowDownIcon />
                )}
              </Th>
              {(user.idRol === "admin" ||
                user.idRol === "coorOp" ||
                user.idRol === "usuarioIT") && (
                <Th
                  // padding={0}
                  // marging={0}
                  // width={seleccionado ? "5%" : "4%"}
                  textAlign={"left"}
                  // paddingRight={"4px"}
                >
                  Acciones
                </Th>
              )}
            </Tr>
          </Thead>
          <Tbody
            textAlign="center"
            // alignItems={"center"}
            // display={"block"}
            // height={"calc(100vh - 200px)"}
            // overflowY={"auto"}
          >
            {loading ? (
              <CircularProgress
                isIndeterminate
                color="brand.naranja"
                position={"relative"}
                top={"50%"}
                left={"50%"}
              />
            ) : (
              filteredEtapas.map((etapa) => (
                <Tr
                  key={etapa.idEtapaSC}
                  onClick={() => {
                    setSeleccionado(etapa);
                    setOpenDetalle((prevValue) =>
                      etapa.idEtapaSC === prevValue ? "" : etapa.idEtapaSC
                    );
                  }}
                  // w={"100%"}
                >
                  <Td
                    // padding={0}
                    // paddingBlock={1.5}
                    // paddingRight={5}
                    // marging={0}
                    textAlign={"left"}
                    // width={"20.72%"}
                  >
                    {etapa.padLocacion || "No informado"}
                  </Td>
                  <Td
                    textAlign={"end"}
                    // padding={0}
                    // paddingBlock={1.5}
                    // paddingRight={5}
                    // marging={0}
                    // width={"8%"}
                  >
                    {etapa.numTotalEtapaSC || "No informado"}
                  </Td>
                  <Td
                    textAlign={"end"}
                    // padding={0}
                    // paddingBlock={1.5}
                    // paddingRight={5}
                    // marging={0}
                    // width={"9%"}
                  >
                    {etapa.numPozoEtapaSC || "No informado"}
                  </Td>
                  <Td
                    textAlign={"left"}
                    // padding={0}
                    // paddingBlock={1.5}
                    // paddingRight={5}
                    // marging={0}
                    // width={"12.5%"}
                  >
                    {etapa.pozo?.nombrePozo || "No informado"}
                  </Td>
                  <Td
                    textAlign={"left"}
                    // padding={0}
                    // paddingBlock={1.5}
                    // paddingRight={5}
                    // marging={0}
                    // width={"11%"}
                  >
                    {etapa.etapaWeTSanD === true ? "SI" : "NO"}
                  </Td>
                  <Td
                    textAlign={"left"}
                    // padding={0}
                    // paddingBlock={1.5}
                    // paddingRight={5}
                    // marging={0}
                    // width={"12%"}
                  >
                    {moment(etapa.fechaFinalEtapaSC).format("DD-MM-YYYY")}
                  </Td>
                  <Td
                    textAlign={"center"}
                    // padding={0}
                    // paddingBlock={1.5}
                    // paddingRight={5}
                    // marging={0}
                    // width={seleccionado ? "3%" : "7.5%"}
                  >
                    {etapa.sandCubes ? etapa.sandCubes.length : 0}
                  </Td>
                  <Td
                    textAlign={"right"}
                    // padding={0}
                    // paddingBlock={1.5}
                    // paddingRight={5}
                    // marging={0}
                    // width={seleccionado ? "3.5%" : "7.5%"}
                  >
                    {regionalFormattingNumbers({
                      number: etapa.consumidoSC,
                      digits: 2,
                    }) ?? 0}
                  </Td>
                  <Td
                    textAlign={"right"}
                    // padding={0}
                    // paddingBlock={1.5}
                    // paddingRight={5}
                    // marging={0}
                    // width={seleccionado ? "3%" : "7.5%"}
                  >
                    {regionalFormattingNumbers({
                      number: etapa.consumidoGranel,
                      digits: 2,
                    }) ?? 0}
                  </Td>
                  <Td
                    textAlign={"right"}
                    // padding={0}
                    // paddingBlock={1.5}
                    // paddingRight={5}
                    // marging={0}
                    // width={seleccionado ? "3%" : "7.5%"}
                  >
                    {regionalFormattingNumbers({
                      number: tnsToLbs(etapa.consumidoGranel),
                      digits: 2,
                    }) ?? 0}
                  </Td>
                  <Td
                    textAlign={"right"}
                    // padding={0}
                    // paddingBlock={1.5}
                    // paddingRight={5}
                    // marging={0}
                    // width={seleccionado ? "3%" : "5.5%"}
                  >
                    {regionalFormattingNumbers({
                      number: etapa.consumidoTotal,
                      digits: 2,
                    }) ?? 0}
                  </Td>
                  <Td
                    textAlign={"left"}
                    // padding={0}
                    // paddingBlock={1.5}
                    // marging={0}
                    // width={"5%"}
                  >
                    {(user.idRol === "admin" ||
                      user.idRol === "coorOp" ||
                      user.idRol === "usuarioIT") && (
                      <>
                        <EditarEtapa
                          seleccionado={etapa}
                          initData={initData}
                          user={user}
                        />
                        <EliminarEtapa
                          seleccionado={etapa}
                          initData={initData}
                          user={user}
                        />
                      </>
                    )}
                  </Td>
                </Tr>
              ))
            )}
          </Tbody>
        </Table>
      </TableContainer>
    </Stack>
  );
}

export default TablaEtapas;
